export const qualificationTabClass = 'px-6 py-3 rounded-full text-label-reg font-bold';

const qualificationNameMap: Record<string, string> = {
    Spark: 'Lumina Spark',
    Leader: 'Lumina Leader',
    Sales: 'Lumina Sales',
    Talent: 'Lumina Select v1',
    ProfessionalCap: 'Professional Capabilities',
    Youth: 'Lumina Youth',
    EmotionalAgility: 'Lumina Emotion',
    NHSSelect: 'NHS Select',
    OTECSelect: 'OTEC Select',
    SelectV2: 'Lumina Select',
    EmotionEnhanced: 'Lumina Emotion Enhanced',
    Bae: 'BAE',
    Swo: 'SWO',
    Forvia: 'Forvia',
};

// eslint-disable-next-line max-len
export const qualificationTabLabel = (qualificationName: string): string => qualificationNameMap[qualificationName] ?? qualificationName;
